import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = { class: "plan-details" }
const _hoisted_3 = { class: "bordered-card overflow-visible sm-p-0 gap-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "pdb-10" }, " Payments and Contributions ", -1)
const _hoisted_5 = { class: "striped small toggle equal-widths claims no-underline" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["colspan"]
const _hoisted_8 = { class: "table-row_wrapper d-flex flex-column gap-20" }
const _hoisted_9 = { class: "d-flex justify-content-between flex-wrap flex-md-nowrap gap-20" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "toggle-cell view-details"
}
const _hoisted_12 = { class: "cell-header hide-desktop" }
const _hoisted_13 = {
  key: 0,
  class: "subitems-columns p-15 sm-pdl-5 sm-pdr-0 sm-pdt-0"
}
const _hoisted_14 = { class: "d-flex flex-column gap-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "text-dark fw-bold sm-fs-xs" }, " Details ", -1)
const _hoisted_16 = { class: "d-flex subitems-columns_details" }
const _hoisted_17 = { class: "d-flex flex-column gap-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, " Date Issued ", -1)
const _hoisted_19 = { class: "sm-fs-xs" }
const _hoisted_20 = { class: "d-flex flex-column gap-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, " Payment Type ", -1)
const _hoisted_22 = { class: "sm-fs-xs" }
const _hoisted_23 = { class: "d-flex flex-column gap-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, " Clear Date ", -1)
const _hoisted_25 = { class: "sm-fs-xs" }
const _hoisted_26 = { class: "d-flex flex-column gap-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", { class: "text-dark fw-bold sm-fs-xs" }, " Deductions ", -1)
const _hoisted_28 = { class: "d-flex subitems-columns_details" }
const _hoisted_29 = { class: "d-flex flex-column gap-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, " Gross ", -1)
const _hoisted_31 = { class: "sm-fs-xs" }
const _hoisted_32 = { class: "d-flex flex-column gap-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, " Deductions ", -1)
const _hoisted_34 = { class: "sm-fs-xs" }
const _hoisted_35 = { class: "d-flex flex-column gap-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, " Net ", -1)
const _hoisted_37 = { class: "sm-fs-xs" }
const _hoisted_38 = { class: "d-flex flex-column gap-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h5", { class: "text-dark fw-bold sm-fs-xs" }, " Destination ", -1)
const _hoisted_40 = {
  key: 0,
  class: "d-flex flex-column gap-2"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, " Address ", -1)
const _hoisted_42 = { class: "sm-fs-xs" }
const _hoisted_43 = {
  key: 1,
  class: "d-flex subitems-columns_details"
}
const _hoisted_44 = { class: "d-flex flex-column gap-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", null, "Bank Name", -1)
const _hoisted_46 = { class: "sm-fs-xs" }
const _hoisted_47 = {
  key: 0,
  class: "d-flex subitems-columns_details"
}
const _hoisted_48 = { class: "d-flex flex-column gap-2" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", null, "Account Number", -1)
const _hoisted_50 = { class: "sm-fs-xs" }
const _hoisted_51 = { class: "d-flex flex-column gap-2" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", null, "Routing Number", -1)
const _hoisted_53 = { class: "sm-fs-xs" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { key: 1 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("tr", { class: "parent-row" }, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "cell text-center",
    colspan: "6"
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "No data available")
  ])
], -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "plan-details w-auto w-sm-100" }
const _hoisted_59 = { class: "account-actions" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h4", null, " Related Links ", -1)
const _hoisted_61 = { class: "action-buttons sm-pdr-0 sm-pdl-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_ProfileInfo = _resolveComponent("ProfileInfo")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ProfileInfo, {
            type: "pension",
            items: _ctx.firstCard,
            "has-divider": false,
            "use-container": true
          }, null, 8, ["items"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pensionStore.paymentHistory.headers, (header, key) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: key,
                    class: _normalizeClass({ 'pdl-50': key === 0 })
                  }, _toDisplayString(header.title), 3))
                }), 128))
              ])
            ]),
            (_ctx.pensionStore.paymentHistory?.rows?.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pensionStore.paymentHistory?.rows, (row, mainKey) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: mainKey,
                      class: "parent-row sm-pdl-10 sm-pdr-10"
                    }, [
                      _createElementVNode("td", {
                        colspan: _ctx.pensionStore.paymentHistory?.headers.length
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.Parent, (item, key) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: key,
                                class: "cell d-flex gap-10",
                                onClick: ($event: any) => (row.Children && key.toString()  === 'Date' ? _ctx.toggleCell(mainKey) : null)
                              }, [
                                (row.Children && key.toString() === 'Date')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.toggleStates[mainKey] ? '-' : '+'), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("p", _hoisted_12, _toDisplayString(key), 1),
                                _createElementVNode("p", {
                                  class: _normalizeClass(["cell-text", { 'toggle-cell': key.toString() === 'Date' }])
                                }, _toDisplayString(_ctx.isNumeric(item) && key.toString() != 'Check#'? _ctx.formatCurrency(item) : item), 3)
                              ], 8, _hoisted_10))
                            }), 128))
                          ]),
                          _createVNode(_Transition, { name: "slide-fade" }, {
                            default: _withCtx(() => [
                              (_ctx.toggleStates[mainKey] && row.Children)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(row.Children), (child, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "d-flex subitems-columns_wrapper",
                                        key: index
                                      }, [
                                        _createElementVNode("div", _hoisted_14, [
                                          _hoisted_15,
                                          _createElementVNode("div", _hoisted_16, [
                                            _createElementVNode("div", _hoisted_17, [
                                              _hoisted_18,
                                              _createElementVNode("h5", _hoisted_19, _toDisplayString(child.Date), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_20, [
                                              _hoisted_21,
                                              _createElementVNode("h5", _hoisted_22, _toDisplayString(child.PaymentDestination ?? '-'), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_23, [
                                              _hoisted_24,
                                              _createElementVNode("h5", _hoisted_25, _toDisplayString(child.ClearDate), 1)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(['divider', { 'hide-mobile': index % 2 === 1 }])
                                        }, null, 2),
                                        _createElementVNode("div", _hoisted_26, [
                                          _hoisted_27,
                                          _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("div", _hoisted_29, [
                                              _hoisted_30,
                                              _createElementVNode("h5", _hoisted_31, _toDisplayString(_ctx.formatCurrency(child.Gross)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_32, [
                                              _hoisted_33,
                                              _createElementVNode("h5", _hoisted_34, _toDisplayString(_ctx.formatCurrency(child.Deductions)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_35, [
                                              _hoisted_36,
                                              _createElementVNode("h5", _hoisted_37, _toDisplayString(_ctx.formatCurrency(child.Net)), 1)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(['divider', { 'hide-mobile': index % 2 === 1 }])
                                        }, null, 2),
                                        _createElementVNode("div", _hoisted_38, [
                                          _hoisted_39,
                                          (child.PaymentDestination === 'Address')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                _hoisted_41,
                                                _createElementVNode("h5", _hoisted_42, _toDisplayString(child.Destination ? JSON.parse(child.Destination)?.FullAddress : '-'), 1)
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                _createElementVNode("div", _hoisted_44, [
                                                  _hoisted_45,
                                                  _createElementVNode("h5", _hoisted_46, _toDisplayString(child.Destination ? JSON.parse(child.Destination).BankClassDescription : '-'), 1)
                                                ]),
                                                _createVNode(_Transition, { name: "fade" }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.toggleBanks[mainKey])
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                          _createElementVNode("div", _hoisted_48, [
                                                            _hoisted_49,
                                                            _createElementVNode("h5", _hoisted_50, _toDisplayString(child.Destination ? JSON.parse(child.Destination).BankAcctNo : '-'), 1)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_51, [
                                                            _hoisted_52,
                                                            _createElementVNode("h5", _hoisted_53, _toDisplayString(child.Destination ? JSON.parse(child.Destination).RoutingCode : '-'), 1)
                                                          ])
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createElementVNode("button", {
                                                  onClick: _withModifiers(($event: any) => (_ctx.toggleBank(mainKey)), ["prevent"]),
                                                  class: _normalizeClass(["ml-2 text-underline fw-bold text-dark button-slide", { 'bounce-right': !_ctx.isVisible }])
                                                }, _toDisplayString(_ctx.toggleBanks[mainKey] ? 'Hide' : 'Show'), 11, _hoisted_54)
                                              ]))
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ], 8, _hoisted_7)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_55, _hoisted_57))
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createVNode(_component_ProfileInfo, {
            title: "Tax Details",
            items: _ctx.secondCard,
            "has-divider": true,
            multiple: _ctx.pensionStore.taxDetails.length,
            classes: "pdb-35",
            actionButton: ""
          }, null, 8, ["items", "multiple"])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _hoisted_60,
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("button", {
              class: "btn btn-secondary plan-modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('add-beneficiary',
                'My Beneficiary(ies)',
                'plan-tables-striped beneficiary',
                null,
                null,
                null,
                )))
            }, " Beneficiary(ies) "),
            (_ctx.isPensioner)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    class: "btn btn-tertiary btn-large plan-modal",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('check-destination', 'Payment Destination Setup', 'plan-form', 'pension')))
                  }, " ACH/Check Destination"),
                  (_ctx.hasChecks)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-tertiary btn-large plan-modal",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal('check-replacement', 'Check Replacement', 'plan-form', 'pension')))
                      }, " Check Replacement "))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("a", {
                    href: "",
                    class: "btn btn-tertiary btn-large plan-modal",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openModal('pension-application', 'Pension Application', 'plan-form', 'application')), ["prevent"]))
                  }, "Pension Application "),
                  _createElementVNode("a", {
                    href: "",
                    class: "btn btn-tertiary btn-large plan-modal",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.openModal('pension-application', 'Estimate Request', 'plan-form', 'estimate')), ["prevent"]))
                  }, " Estimate Request ")
                ], 64)),
            _createElementVNode("a", {
              href: "",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.openModal('plan-resources', 'Pension Forms & Documents', null, 'pension')), ["prevent"])),
              class: "btn btn-tertiary btn-large plan-modal"
            }, "Forms & Documents ")
          ])
        ])
      ]))
}